// extracted by mini-css-extract-plugin
export default {"main":"Layout_main__G6Lpl","container":"Layout_container__9cXS-"};